import { Fragment, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSpeechSDK } from '../../Helpers/Conversation/SpeechDetection';
import { createAudioFromBlob } from '../../Helpers/Util/AudioHelpers';

const MainAudioPlayer = (props) => {
  const [mainAudioSource, setMainAudioSource] = useState();
  const npcAudioBlobs = useSelector((state) => state.npcAudioBlobs);
  const playNpcAudio = useSelector((state) => state.playNpcAudio);
  const activeSection = useSelector((state) => state.activeSection);
  const preteachActive = useSelector((state) => state.preteachActive);
  const main_player = useRef();
  const dispatch = useDispatch();
  // const isSafari =
  //   navigator.vendor &&
  //   navigator.vendor.indexOf('Apple') > -1 &&
  //   navigator.userAgent &&
  //   navigator.userAgent.indexOf('CriOS') == -1 &&
  //   navigator.userAgent.indexOf('FxiOS') == -1;

  const playMainAudio = () => {
    main_player.current.play().catch((error) => {
      console.warn(`Couldn't play main audio: ${error}`);
    });
  };

  //Watch For Play Request
  useEffect(() => {
    if (playNpcAudio === true && main_player.current !== undefined) {
      //Shouldn't load more than 5 sections so don't want to play audio for section 6 or more
      if (activeSection >= 5) return;

      //Don't play if already playing
      if (!main_player.current.paused) return;

      if (npcAudioBlobs[activeSection] !== undefined) {
        // console.log(`play section: ${activeSection}`)
        setMainAudioSource(createAudioFromBlob(npcAudioBlobs[activeSection]));
        // if (isSafari && activeSection === 0) return;
        main_player.current.load();
        playMainAudio();
      }
    }

    if (playNpcAudio === false && mainAudioSource !== '') {
      URL.revokeObjectURL(mainAudioSource);
    }
  }, [playNpcAudio]);

  //Watch For Active Section changing so we can update audio blob and play it
  useEffect(() => {
    if (npcAudioBlobs.length && main_player.current) {
      if (preteachActive === true) return;
      try {
        let audioFragmentsLength = npcAudioBlobs ? npcAudioBlobs.length : 5;
        //Shouldn't load more than 5 sections so don't want to play audio for section 6 or more
        if (activeSection >= audioFragmentsLength ) return;

        if (npcAudioBlobs[activeSection] !== undefined) {
          setMainAudioSource(createAudioFromBlob(npcAudioBlobs[activeSection]));
        }

        //Don't play if already playing
        if (!main_player.current.paused) return;
        // console.log(`section updated, play section: ${activeSection}`)

        //Only load and play if the active section is not 0 as this means we're in the conversation
        //active section is set to 0 when we return to start screen so don't want to play it then
        if (activeSection !== 0) {
          main_player.current.load();
          playMainAudio();
        }
      } catch (error) {
        console.warn(error);
      }
    }
  }, [activeSection, npcAudioBlobs]);

  //Clean up for memory
  useEffect(() => {
    return () => {
      URL.revokeObjectURL(mainAudioSource);
    };
  }, []);

  useEffect(() => {
    if (npcAudioBlobs.length) {
      setMainAudioSource(createAudioFromBlob(npcAudioBlobs[activeSection]));
    }
  }, [npcAudioBlobs]);

  useEffect(() => {
    if (main_player && main_player.current) {
      //When audio is ready hide loading screen
      main_player.current.addEventListener('canplaythrough', () => {
        // console.log('I think I can play through the entire audio');
        setTimeout(function () {
          props.playerReady();
        }, 500);
      });

      //IOS doesn't use canplaythrough event so have to use this one instead
      main_player.current.addEventListener('loadedmetadata', () => {
        if (useSpeechSDK()) {
          setTimeout(function () {
            props.playerReady();
          }, 500);
        }
        // console.log('loaded meta data');
      });

      main_player.current.addEventListener('error', (error) => {
        console.log('error with main_player: Details: ' + error);
      });

      // main_player.current.addEventListener('abort', (event) => {
      // 	console.log('aborted');
      // });

      // main_player.current.addEventListener('canplay', (event) => {
      // 	console.log('can play');
      // });

      // main_player.current.addEventListener('loadeddata', (event) => {
      // 	console.log('loaded data');
      // });

      // main_player.current.addEventListener('play', (event) => {
      // 	console.log('playing');
      // });

      // main_player.current.addEventListener('paused', (event) => {
      // 	console.log('paused');
      // });

      // main_player.current.addEventListener('progress', (event) => {
      // 	console.log('progress');
      // });

      // main_player.current.addEventListener('stalled', (event) => {
      // 	console.log('stalled');
      // });

      // main_player.current.addEventListener('suspend', (event) => {
      // 	console.log('suspended');
      // });

      // main_player.current.addEventListener('waiting', (event) => {
      // 	console.log('waiting');
      // });

      // main_player.current.addEventListener('loadedmetadata', (event) => {
      // 	console.log('loadedmeta');
      // 	setIsFetching(false);
      // });
      main_player.current.addEventListener('ended', function () {
        // console.log('npc finished')
        if (activeSection !== 'undefined') {
          dispatch({
            type: 'stopNpcAudio',
          });
        }
      });

      // main_player.current.load();

      // return () => {
      // 	if( main_player && main_player.current ) {
      // 		main_player.current.removeEventListener('ended', function() {
      // 			setNpcFinished({
      // 				value: true,
      // 				order: convContext.activeSection
      // 			});
      // 		})
      // 	}
      // }
    }
  }, [mainAudioSource, npcAudioBlobs]);

  return (
    <Fragment>
      {mainAudioSource && (
        <audio id="main_audio_player" ref={main_player}>
          <source
            id="main_player_source"
            src={mainAudioSource}
            type="audio/mpeg"
          />
        </audio>
      )}
    </Fragment>
  );
};

export default MainAudioPlayer;
